import axios from "axios";

import { IDiscordMessage } from "@/shared/model/discord.model";

const baseApiUrl = "api/discord";
export default class DiscordService {
  public getAnnouncements(): Promise<IDiscordMessage[]> {
    return new Promise<IDiscordMessage[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/announcement`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
